// 47283 (R-EB): the document font on the web. The API serves one family's @font-face (data: URIs) + its CSS stack; this injects it once and gives the sheet / the settings
// preview the stack to draw with, so the on-screen document is in the same family as the server PDF. No font key (a document frozen before 47283) = nothing loaded, the sheet keeps its look.
import { useEffect, useState } from 'react';
import api from '../../services/api';

const loaded = new Map();   // `${key}|${sample}` -> Promise<stack | null>
export function loadDocFont(key, sample = false) {
  if (!key) return Promise.resolve(null);
  const id = `${key}|${sample ? 1 : 0}`;
  if (!loaded.has(id)) {
    loaded.set(id, api.getDocumentFontCss(key, sample).then((r) => {
      if (!r || !r.css) { loaded.delete(id); return null; }   // 47283d: an empty answer is never remembered (the sheet would stay in the app font until a reload)
      const el = document.createElement('style'); el.setAttribute('data-doc-font', id); el.textContent = r.css; document.head.appendChild(el);
      return r.stack || null;
    }).catch(() => { loaded.delete(id); return null; }));
  }
  return loaded.get(id);
}
// the CSS font-family stack of `key` once its face is loaded (undefined until then / without a key)
export function useDocFont(key, sample = false) {
  const [stack, setStack] = useState(undefined);
  useEffect(() => { let alive = true; setStack(undefined); loadDocFont(key, sample).then((s) => { if (alive && s) setStack(s); }); return () => { alive = false; }; }, [key, sample]);
  return stack;
}
